module.exports = __webpack_public_path__ + "img/0.444ff19e.png";